function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @class EventEmitter
 *
 * @property {Array} _listeners
 */
var EventEmitter = /*#__PURE__*/function () {
  /**
   * Construct EventEmitter
   * 
   * @param {Array} listeners 
   */
  function EventEmitter() {
    var listeners = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    _classCallCheck(this, EventEmitter);

    this._listeners = new Map(listeners);
    this._events = new Map();
  }
  /**
      * Destroys EventEmitter
      */


  _createClass(EventEmitter, [{
    key: "destroy",
    value: function destroy() {
      this._listeners = {};
      this.events = [];
    }
    /**
     * Count listeners registered for the provided eventName
     * 
     * @param {string} eventName 
     */

  }, {
    key: "listenerCount",
    value: function listenerCount(eventName) {
      if (!this._listeners.has(eventName)) {
        return 0;
      }

      return this._listeners.get(eventName).length;
    }
    /**
        * Subscribes on event eventName specified function
     * 
        * @param {string} eventName
        * @param {function} listener
        */

  }, {
    key: "on",
    value: function on(eventName, listener) {
      this._addListener(eventName, listener, false);
    }
    /**
        * Subscribes on event name specified function to fire only once
     * 
        * @param {string} eventName
        * @param {function} listener
        */

  }, {
    key: "once",
    value: function once(eventName, listener) {
      this._addListener(eventName, listener, true);
    }
    /**
        * Removes event with specified eventName.
     * 
        * @param {string} eventName
        */

  }, {
    key: "off",
    value: function off(eventName) {
      this._removeListeners(eventName);
    }
    /**
        * Emits event with specified name and params.
     * 
        * @param {string} eventName
        * @param eventArgs
        */

  }, {
    key: "emit",
    value: function emit(eventName) {
      for (var _len = arguments.length, eventArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        eventArgs[_key - 1] = arguments[_key];
      }

      return this._applyEvents(eventName, eventArgs);
    }
    /**
     * Register a new listener
     * 
     * @param {string} eventName 
     * @param {function} listener 
     * @param {bool} once 
     */

  }, {
    key: "_addListener",
    value: function _addListener(eventName, listener) {
      var _this = this;

      var once = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (Array.isArray(eventName)) {
        eventName.forEach(function (e) {
          return _this._addListener(e, listener, once);
        });
      } else {
        eventName = eventName.toString();
        var split = eventName.split(/,|, | /);

        if (split.length > 1) {
          split.forEach(function (e) {
            return _this._addListener(e, listener, once);
          });
        } else {
          if (!Array.isArray(this._listeners.get(eventName))) {
            this._listeners.set(eventName, []);
          }

          this._listeners.get(eventName).push({
            once: once,
            fn: listener
          });
        }
      }
    }
    /**
     * 
     * @param {string|null} eventName 
     */

  }, {
    key: "_removeListeners",
    value: function _removeListeners() {
      var _this2 = this;

      var eventName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (eventName !== null) {
        if (Array.isArray(eventName)) {
          name.forEach(function (e) {
            return _this2.removeListeners(e);
          });
        } else {
          eventName = eventName.toString();
          var split = eventName.split(/,|, | /);

          if (split.length > 1) {
            split.forEach(function (e) {
              return _this2.removeListeners(e);
            });
          } else {
            this._listeners.delete(eventName);
          }
        }
      } else {
        this._listeners = new Map();
      }
    }
    /**
        * Applies arguments to specified event
     * 
        * @param {string} eventName
        * @param {*[]} eventArguments
        * @protected
        */

  }, {
    key: "_applyEvents",
    value: function _applyEvents(eventName, eventArguments) {
      var result = eventArguments;

      if (this._listeners.has(eventName)) {
        var listeners = this._listeners.get(eventName);

        var removableListeners = [];
        listeners.forEach(function (listener, index) {
          if (result = listener.fn.apply(null, eventArguments)) {
            if (listener.once) {
              removableListeners.unshift(index);
            }
          }
        });
        removableListeners.forEach(function (index) {
          listeners.splice(index, 1);
        });
        return result;
      }

      return result[0];
    }
  }]);

  return EventEmitter;
}();

export { EventEmitter as default };